import API from './API.js'

export default class Faqs extends API {
  constructor() {
    super('faqs')
  }
}
